import api from "@/api";


//导出列表
export const oilSiteDataExport = (data) => {
    return api.axss("post", `/ocm-oil-site/oilSiteDataExport/list`,data)
  }

  //根据设备查润滑点
export const getByDeviceId = (data) => {
    return api.axss("post", `/ocm-oil-site/oil-site/getByDeviceId`,data)
  }


    //导出表单
export const oilSiteDataExportinert = (data) => {
    return api.axss("post", `/ocm-oil-site/oilSiteDataExport/insert`,data)
  }
